var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['room-booked', { disabled: _vm.disabled, saturday: _vm.isSaturday, monday: _vm.isMonday }]},[_vm._v(_vm._s(_vm.quantity))])}
var staticRenderFns = []

export { render, staticRenderFns }